import type { FaireProductEntity } from "../../entity_types/product";

export const p_2nf9rc7xa4: FaireProductEntity = {
  token: "p_2nf9rc7xa4",
  type: "product",
  name: "Sumac & Lemon Sea Salt",
  brandToken: "b_xhgxgkda5f",
  brandName: "Jar Masala",
  imageUrl:
    "https://cdn.faire.com/fastly/9284b68dc843f4411a86b6bd59bde9bbeef63f178dfd1c07a8b5863cfc237973.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f52d2aac3d054da3a9e476b3c5353248509bd9926fe64c79cf3afff89fc86d2.jpeg",
    "https://cdn.faire.com/fastly/78bf2c08dc42364e65aa5b82dfceba04fa8b46d2417e972e68616eea29dae027.jpeg",
    "https://cdn.faire.com/fastly/d93820e3e07a8ad7d24b5ad5c78fe1a7ce78417d24470222da97930f115bc353.jpeg",
    "https://cdn.faire.com/fastly/1d68fd46de3f66dbef14cbc844b60e62268e48c81ea4f815d21435a40d413bdf.jpeg",
  ],
  priceDollars: 7.62,
  description:
    "Elevate your dishes with our vibrant Mediterranean inspired Sumac and Lemon coarse Sea Salt blend, featuring tangy sumac and zesty lemon flavors for a refreshing citrus pop. This versatile, bright seasoning blend adds a tart, and savory punch, perfect as a finishing salt for salads, grilled meats, hummus, and vegetables. \n\nHow to Use Tips:\nPerfect as a finishing salt: Sprinkle on avocados, toast, eggs for a vibrant crunch. \nExcellent for Mediterranean and Middle Eastern dishes, including salads, lamb, seafood, kebabs, yogurt dips, olive-oil-based vinaigrettes and roasted vegetables.\n\n4oz. | $5.50\nAromatic spices are roasted and blended in small batches to ensure optimal flavor and freshness.\nPremium, great quality ingredients blended with flavors in mind. \nGourmet blend by a women-owned artisanal spice company in Snellville, GA. \nHandcrafted in the USA from imported and local ingredients.\n\n*Wooden Spice Spoon included w/4oz. Jar",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:28.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
